import React from 'react';
import { Link } from 'react-router-dom';
import styled from "styled-components";

const NavUnlisted = styled.a`
  text-decoration: none;
`;

// Simulated blog post data (replace with your actual blog data)
const blogPosts = [
  {
    id: 11,
    title: 'MACROECONOMICS — Summary',
		link: "https://medium.com/@caneradilirfanoglu/macroeconomics-summary-cb4fff8c12b0"

  },
  {
    id: 12,
    title: 'MAKROEKONOMİ — ÖZETİ',
		link: "https://medium.com/@caneradilirfanoglu/makroekonomi-özeti̇-873193fe89a4"

  },
	{
    id: 5,
    title: 'Advances In Financial Machine Learning — PART 0 — INTRO',
		link: "https://medium.com/@caneradilirfanoglu/advances-in-financial-machine-learning-part-0-intro-af18a8a295d5"
  },
	{
    id: 6,
    title: 'AFML — PART 1 — DATA ANALYSIS',
		link: "https://medium.com/@caneradilirfanoglu/afml-part-1-data-analysis-f237af7e83c4"
  },
  	{
    id: 7,
    title: 'AFML — PART 2 — MODELLING',
		link: "https://medium.com/@caneradilirfanoglu/afml-part-2-modelling-55e65bddd62c"
  },
  	{
    id: 8,
    title: 'AFML — PART 3 — BACKTESTING',
		link: "https://medium.com/@caneradilirfanoglu/advances-in-financial-machine-learning-part-3-backtesting-a9d70f0832c2"
  },
  	{
    id: 9,
    title: 'AFML — PART 4— USEFUL FINANCIAL FEATURES',
		link: "https://medium.com/@caneradilirfanoglu/afml-part-4-useful-financial-features-336bb4c9607e5"
  },
  	{
    id: 10,
    title: 'AFML — PART 5 — HIGH-PERFORMANCE COMPUTING RECIPES',
		link: "https://medium.com/@caneradilirfanoglu/part-5-high-performance-computing-recipes-79a1aa1027fb"
  },
  {
    id: 1,
    title: 'Recognizing over 50 Candlestick Patterns with Python',
		link: "https://medium.com/analytics-vidhya/recognizing-over-50-candlestick-patterns-with-python-4f02a1822cb5"
  },
  {
    id: 2,
    title: 'Learnings from creating a cryptocurrency web app',
		link: "https://medium.com/plotly/learnings-from-creating-a-cryptocurrency-web-app-1cd379278909"
  },
	{
    id: 3,
    title: 'Learn, prepare and predict for the next crypto bull market',
		link: "https://medium.com/@caneradilirfanoglu/part-1-learn-prepare-and-predict-for-the-next-crypto-bull-market-9386b2d16ede"
  },
	{
    id: 4,
    title: 'Decentralized Finance in Practice: My Polkadot Staking Story',
		link: "https://medium.com/@caneradilirfanoglu/decentralized-finance-in-practice-my-polkadot-staking-story-d9b8f6ed464"
  },



];

const StyledLink = styled(Link)`
  text-decoration: none;
  color: black;
  font-size: 1.875rem; /* Equivalent to text-3xl */
  font-weight: 300;   /* Equivalent to font-semibold */
  margin: 1rem;
  text-align: center; /* Equivalent to text-center */

  &:hover {
    color: purple; 
	}
	@media (max-width: 768px) {
    font-size: 1.25rem; /* Change font size for smaller screens */
  }
`;

function Blog() {
  return (
    <div className="container mx-auto mt-8">
      <h1 className="text-3xl font-semibold mb-5 text-center">medium</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ">
        {blogPosts.map((post) => (
          <NavUnlisted>
						<div key={post.id}>
							<StyledLink to={post.link} target="_blank">
								{post.title}
							</StyledLink>
							<p className="text-gray-700">{post.content}</p>
							<hr></hr>
						</div>
					</NavUnlisted>
        ))}
      </div>
    </div>
  );
}

export default Blog;
